import { ThemeOptions } from "@mui/material";
import { typographyVariants } from "../constants";

export const muiFormLabel: ThemeOptions["components"] = {
  MuiFormLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...typographyVariants.bodyMedium,
        color: theme.palette.secondary.main,
        transform: "translate(0, -1px) scale(1) !important",
        "&.Mui-focused": {
          color: theme.palette.primary.main,
        },
        "&.Mui-error": {
          color: theme.palette.secondary.main,
        },
      }),
    },
  },
};
